import type { Replacements } from "@lib/utils/interpolateText";

export type MicrocopySetKey = "shared" | "page" | string;

export type MicrocopyGetOptions = {
    replacements?: Replacements;
    fromMultiple?: boolean;
};

export interface MicrocopySet {
    [key: string]: {
        id: string;
        key: string;
        value: string;
    };
}

export interface MicrocopyContextState {
    shared: MicrocopySet;
    page: MicrocopySet;
    [key: string]: MicrocopySet;
}

export interface MicrocopyContextAPI {
    get: (
        microcopySetKey: MicrocopySetKey,
        microcopyKey: string,
        options?: MicrocopyGetOptions
    ) => string | null;
    getMultiple: (
        microcopySetKey: MicrocopySetKey,
        microcopyKeys: string[],
        options?: MicrocopyGetOptions
    ) => { [key: string]: string } | null;
}

export enum LogMicrocopyType {
    GET_SINGLE = "getSingle",
    GET_MULTIPLE = "getMultiple",
}

export enum LogMicrocopyError {
    MISSING_MICROCOPY_SET = "Missing Microcopy Set",
    MISSING_MICROCOPY = "Missing Microcopy",
}
